(function () {

  const CSS = `
    .io-swatch-wrapper { position: relative; }

    .io-swatch-trigger {
      display: flex; align-items: center; gap: 6px;
      padding: 4px 14px; cursor: pointer; user-select: none;
      border: 1px solid #d0d0d0; border-radius: 4px;
      background: #fff; min-height: 48px; box-sizing: border-box;
      width: 100%;
    }
    .io-swatch-trigger:hover { border-color: #999; }

    .io-swatch-trigger img {
      width: 35px; height: 35px; border-radius: 3px;
      border: 1px solid #e0e0e0; object-fit: cover; flex-shrink: 0;
    }
    .io-swatch-trigger .io-swatch-label {
      flex: 1; text-align: left; color: rgba(var(--color-foreground), 0.75) !important;
      font-size: 1.3rem !important;
    }

    .io-swatch-trigger .io-chevron {
      font-size: 16px !important; line-height: 1 !important;
      flex-shrink: 0; transition: transform 0.2s;
      color: #666 !important; font-family: serif !important;
    }
    .io-swatch-wrapper.open .io-chevron { transform: rotate(180deg); }

    .io-swatch-list {
      display: none; position: absolute; top: calc(100% + 3px); left: 0; right: 0;
      background: #fff; border: 1px solid #d0d0d0; border-radius: 4px;
      z-index: 9999; max-height: 280px; overflow-y: auto;
      box-shadow: 0 4px 12px rgba(0,0,0,0.1);
    }
    .io-swatch-wrapper.open .io-swatch-list { display: block; }

    .io-swatch-option {
      display: flex; align-items: center; gap: 6px;
      padding: 4px 14px; cursor: pointer;
      border-top: 1px solid #f0f0f0;
    }
    .io-swatch-option:first-child { border-top: none; }
    .io-swatch-option:hover { background: #f8f8f8; }
    .io-swatch-option.selected { background: #f3f3f3; }

    .io-swatch-option img {
      width: 35px; height: 35px; border-radius: 3px;
      border: 1px solid #e0e0e0; object-fit: cover; flex-shrink: 0;
    }
    .io-swatch-option .io-opt-label {
      flex: 1; color: rgba(var(--color-foreground), 0.75) !important;
      font-size: 1.3rem !important;
    }

    .io-check { display: none; flex-shrink: 0;
      fill: none; stroke: #333; stroke-width: 2.5;
      stroke-linecap: round; stroke-linejoin: round;
    }
    .io-swatch-option.selected .io-check { display: block; }

    .io-chart-link {
      display: inline-flex; align-items: center; gap: 4px;
      margin: 4px 0 10px 0; padding: 4px 10px;
      border-radius: 999px; font-size: 1.2rem; font-weight: 500;
      text-decoration: none; background: #EDA0A0; color: #ffffff;
    }
  `;

  function injectStyles() {
    if (document.getElementById('io-swatch-styles')) return;
    const s = document.createElement('style');
    s.id = 'io-swatch-styles';
    s.textContent = CSS;
    document.head.appendChild(s);
  }

  function makeSVG(tag, attrs) {
    const el = document.createElementNS('http://www.w3.org/2000/svg', tag);
    Object.entries(attrs).forEach(([k, v]) => el.setAttribute(k, v));
    return el;
  }

  function chevronSVG() {
    const span = document.createElement('span');
    span.className = 'io-chevron';
    span.setAttribute('aria-hidden', 'true');
    span.textContent = '▾';
    return span;
  }

  function checkSVG() {
    const svg = makeSVG('svg', { viewBox: '0 0 24 24', class: 'io-check', width: '16', height: '16', 'aria-hidden': 'true' });
    svg.appendChild(makeSVG('polyline', { points: '20 6 9 17 4 12' }));
    return svg;
  }

  function findOptionTitle(groupEl) {
    const container = groupEl.parentElement;
    if (container) {
      const label = container.querySelector('label.spb-productdescfont');
      if (label) return label.textContent.trim();
    }
    const prev = groupEl.previousElementSibling;
    if (prev && prev.matches && prev.matches('label.spb-productdescfont')) {
      return prev.textContent.trim();
    }
    let ancestor = groupEl.closest('#infiniteoptions-container') || document.body;
    const labels = ancestor.querySelectorAll('label.spb-productdescfont');
    for (const lbl of labels) {
      if (lbl.compareDocumentPosition(groupEl) & Node.DOCUMENT_POSITION_FOLLOWING) {
        return lbl.textContent.trim();
      }
    }
    return '';
  }

  function appendChartLink(wrapper, optionTitle) {
    if (!window.colorChartMap) return;
    const url = window.colorChartMap[optionTitle];
    if (!url) return;

    const link = document.createElement('a');
    link.href = url;
    link.target = '_blank';
    link.className = 'io-chart-link';
    link.textContent = 'View Color Chart →';

    wrapper.parentNode.insertBefore(link, wrapper.nextSibling);
  }

  function buildDropdown(groupEl) {
    const swatchLabels = groupEl.querySelectorAll('label.spb-productoptionswatchwrapper');
    if (!swatchLabels.length) return;

    if (groupEl.dataset.ioEnhanced) return;
    groupEl.dataset.ioEnhanced = 'true';

    const options = Array.from(swatchLabels).map(label => {
      const input = label.querySelector('input[type="radio"]');
      const swatchSpan = label.querySelector('.spb-productoptionswatch');
      const labelSpan = label.querySelector('.spb-swatchlabel');

      const bgStyle = swatchSpan ? swatchSpan.style.backgroundImage : '';
      const imgUrl = bgStyle.replace(/url\(['"]?|['"]?\)/g, '');

      return {
        input,
        value: input ? input.value : '',
        name: labelSpan ? labelSpan.textContent.trim() : '',
        imgUrl,
        checked: input ? input.checked : false,
      };
    });

    if (!options.length) return;

    swatchLabels.forEach(l => { l.style.display = 'none'; });

    const initial = options.find(o => o.checked) || options[0];

    const wrapper = document.createElement('div');
    wrapper.className = 'io-swatch-wrapper';

    const trigger = document.createElement('button');
    trigger.type = 'button';
    trigger.className = 'io-swatch-trigger';
    trigger.setAttribute('aria-haspopup', 'listbox');
    trigger.setAttribute('aria-expanded', 'false');

    const triggerImg = document.createElement('img');
    triggerImg.src = initial.imgUrl;
    triggerImg.alt = initial.name;

    const triggerLabel = document.createElement('span');
    triggerLabel.className = 'io-swatch-label';
    triggerLabel.textContent = initial.name;

    trigger.appendChild(triggerImg);
    trigger.appendChild(triggerLabel);
    trigger.appendChild(chevronSVG());

    const list = document.createElement('div');
    list.className = 'io-swatch-list';
    list.setAttribute('role', 'listbox');

    options.forEach(opt => {
      const item = document.createElement('div');
      item.className = 'io-swatch-option' + (opt.value === initial.value ? ' selected' : '');
      item.setAttribute('role', 'option');
      item.setAttribute('aria-selected', opt.value === initial.value ? 'true' : 'false');

      const img = document.createElement('img');
      img.src = opt.imgUrl;
      img.alt = opt.name;

      const span = document.createElement('span');
      span.className = 'io-opt-label';
      span.textContent = opt.name;

      item.appendChild(img);
      item.appendChild(span);
      item.appendChild(checkSVG());

      item.addEventListener('click', () => {
        if (opt.input) opt.input.click();

        triggerImg.src = opt.imgUrl;
        triggerImg.alt = opt.name;
        triggerLabel.textContent = opt.name;

        list.querySelectorAll('.io-swatch-option').forEach(el => {
          el.classList.remove('selected');
          el.setAttribute('aria-selected', 'false');
        });
        item.classList.add('selected');
        item.setAttribute('aria-selected', 'true');

        close();
      });

      list.appendChild(item);
    });

    wrapper.appendChild(trigger);
    wrapper.appendChild(list);

    swatchLabels[0].parentNode.insertBefore(wrapper, swatchLabels[0]);

    const optionTitle = findOptionTitle(groupEl);
    if (optionTitle) {
      appendChartLink(wrapper, optionTitle);
    }

    function open() {
      wrapper.classList.add('open');
      trigger.setAttribute('aria-expanded', 'true');
    }
    function close() {
      wrapper.classList.remove('open');
      trigger.setAttribute('aria-expanded', 'false');
    }

    trigger.addEventListener('click', () => {
      wrapper.classList.contains('open') ? close() : open();
    });

    trigger.addEventListener('keydown', e => {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); open(); }
      if (e.key === 'Escape') close();
    });

    document.addEventListener('click', e => {
      if (!wrapper.contains(e.target)) close();
    }, true);
  }

  function scanAndEnhance() {
    document.querySelectorAll('#infiniteoptions-container [role="group"]').forEach(group => {
      if (group.querySelector('label.spb-productoptionswatchwrapper')) {
        buildDropdown(group);
      }
    });
  }

  function init() {
    injectStyles();
    scanAndEnhance();
    new MutationObserver(scanAndEnhance)
      .observe(document.body, { childList: true, subtree: true });
  }

  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', init)
    : init();

})();